import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as APIHelper from '../../../Helper/apiFetch';

/**
 * Custom hook to fetch and manage campaign data
 */
export const useCampaignData = (hasAccessToken, setHasAccessToken) => {
  const navigate = useNavigate();
  const [shimmerLoader, setShimmerLoader] = useState(true);
  const [campaignData, setCampaignData] = useState(null);
  const [campaignConfig, setCampaignConfig] = useState(null);
  const [loadingLevel, setLoadingLevel] = useState({
    levelOne: false,
    levelTwo: false,
    levelThree: false,
  });

  useEffect(() => {
    let tokenPoller = null;

    const fetchCampaignData = async () => {
      setShimmerLoader(true);
      const currentToken = sessionStorage.getItem('AccessToken');
      
      if (!currentToken) {
        return;
      }

      try {
        // Fetch both campaign data and config in parallel
        const [resData, configResponse] = await Promise.all([
          // APIHelper.topFive(),
          // APIHelper.getCampaignConfig().catch(() => null), 
        ]);
        if (resData.error) {
          navigate('/error');
          return;
        }

        // Process campaign config
        if (configResponse && !configResponse.error && configResponse.data) {
          setCampaignConfig(configResponse.data);
        }

        const totalTxnAmount = resData?.totalTxnAmount || 0;
        const totalVoucherTxnAmount = resData?.totalVoucherTxnAmt || 0;
        const progress = Math.min((totalTxnAmount / 100000) * 100, 100);
        const voucherProgress = Math.min((totalVoucherTxnAmount / 10000) * 100, 100);
        
        setCampaignData({
          ...resData,
          progress,
          voucherProgress,
        });
      } catch (error) {
        console.error('Error fetching campaign data:', error);
      } finally {
        setShimmerLoader(false);
      }
    };

    const ensureTokenAndFetch = () => {
      const token = sessionStorage.getItem('AccessToken');
      if (token) {
        setHasAccessToken(true);
        fetchCampaignData();
      } else {
        tokenPoller = setInterval(() => {
          const freshToken = sessionStorage.getItem('AccessToken');
          if (freshToken) {
            clearInterval(tokenPoller);
            setHasAccessToken(true);
            fetchCampaignData();
          }
        }, 500);
      }
    };

    ensureTokenAndFetch();

    return () => {
      if (tokenPoller) {
        clearInterval(tokenPoller);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  return {
    shimmerLoader,
    campaignData,
    setCampaignData,
    campaignConfig,
    loadingLevel,
    setLoadingLevel,
  };
};
